import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@pwc/appkit-react/lib/Radio';

import { YES_FLAG, NO_FLAG } from '../constants';

const defaultOptions = [{ label: 'Yes', value: YES_FLAG }, { label: 'No', value: NO_FLAG }];

const FormRadioInput = ({ name, options = defaultOptions, value, onChange, disabled }) => (
  <div>
    {options.map(option => (
      <span
        key={option.value}
        className="radio-inline"
      >
        <Radio
          name={name}
          disabled={disabled}
          checked={value === option.value}
          value={option.value}
          onChange={onChange}
        >
          {option.label}
        </Radio>
      </span>
    ))}
  </div>
);

FormRadioInput.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FormRadioInput;
